<template>
    <section class="view spacer">
        <vue-headful
            title="Travel View | What goes into a Travel View"
            description="Travel View identifies opportunities to reduce costs per trip by exploring all potential cost drivers. Respond to increasing reporting requirements with visibility into trip and traveler level detail."
            url="https://www.fedsight.com/travel-view"
        />
        <section class='container-fluid d-flex align-items-center justify-content-center'>
        </section>

        <section class='viewIntro'>
            <div class='container'>
                <h1 class='viewHeader fedsightBlue'>TRAVEL VIEW</h1> 
                <p class='viewMainParagraph'>
                    In an environment in which federal travel budgets are decreasing and trips are increasingly scrutinized, organizations need greater visibility into travel detail and costs. Travel View includes comprehensive detail related to travel spending, scope, and purpose which allows organizations to understand how travel is supporting mission objectives. The ability to review and model from a programmatic, organizational, and individual perspective enhances transparency and resource management. Access to historical and real-time information enables effective management and rapid, reliable travel reporting. Visibility into trip and traveler level detail enables trend and pattern recognition. Evaluate mechanisms to reduce travel costs without reducing the volume and outcomes. With Travel View, a limited budget does not have to mean less travel.
                </p>
            </div>
            
        </section>

        <section class='blogPost'>
            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Key Business Questions:
                </h2>
                <ul>
                    <li>
                        Is there a correlation between booking time and cost? If so, how many days in advance on average are travelers booking their trips and could travelers book trips earlier to reduce airfare cost?
                    </li>
                    <li>
                        Is there significant travel volume between two specific locations? If so, are there opportunities to reduce costs through preferred vendors, group bookings, or to negotiate for reduced rates?
                    </li>
                    <li>
                        To what degree have budget reductions impacted trip counts? Has critical programmatic travel been impacted to the same extent as administrative travel? 
                    </li>
                    <li>
                        How do trip counts, total travel costs, and average trip cost compare between organizations, locations, or traveler grade levels?
                    </li>
                    <li>
                        How much travel is driven by conference attendance and how significantly does conference location selection impact travel costs?
                    </li>
                    <li>
                        What travelers should we target directly to provide recommendations for cost savings behaviors?
                    </li>
                </ul>
            </div>

            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Who we are
                </h2>
                <p>
                    Fedsight Consulting is an SBA certified HUBZone small business consulting firm focused on helping organizations improve operations and program performance. Our strategic, financial, and operational support services provide insight and perspective on program performance and operational trends.  Fedsight Consulting’s subject matter expertise, methods, and tools enable federal organizations to accomplish objectives, effectively manage resources, and improve program performance.
                </p>
                <p>
                    To learn more about Fedsight Consulting and discuss potential opportunities, email <span class='emailLink' @click='emailUs()'>info@fedsight.com</span>.
                </p>
            </div>
        </section>

        <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'travel-view',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/travel-view'}
      ]
    },
    mixins: [closeMenu],
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    },
    mounted() {
        document.dispatchEvent(new Event('page.rendered'));
    }
}
</script>

<style scoped>
.viewIntro{
    padding: 8rem 0rem 2rem;
    max-width: 100rem;
    margin: auto;
    text-align: left;
}
.viewHeader{
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    /*background-color: #132631;
    color: #fff; */
    width: 100%;
    padding: 2rem 0rem;
}
.blogPost{
    text-align: left;
}
.blogPostContainer{
    max-width: 100rem;
    margin: 3rem auto;
}
.viewHero{
    height: 30rem;
}
.viewHeader{
    color: #fff;
    font-size: 6rem;
}
.emailLink{
    color: #007bff;
    cursor: pointer;
}
.emailLink:hover{
    color: #0056b3;
    text-decoration: underline;
}
h2{
    margin-top: 3rem;
}


/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>